import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Your invoicing options will be applied by default to all new invoices and quotes.',
    errorMessage:
      'An error occurred while saving your changes. Please try again and if the problem persists, contact us.',
    save: 'Save changes',
    successMessage: 'Changes saved successfully!',
    title: 'Options',
  },
  fr: {
    description:
      'Vos options de facturation seront appliquées par défaut à chaque nouvelle facture et devis.',
    errorMessage:
      'Une erreur est survenue lors de la modification de vos option de facturation. Réessayez et si le problème persiste, contactez-nous.',
    save: 'Sauvegarder les modifications',
    successMessage: 'Modifications enregistrées avec succès !',
    title: 'Options',
  },
} as const);

export default locales;
